/*
 * @Description: 项目配置
 * @Date: 2021-03-22 00:21:31
 */

import { runConfig } from '@xcxConfig/run_config';

export const BASE_DOMAIN = `${window.location.protocol}//${window.location.host}`;

export const BASE_PATH = '/index.html';

export const TOKEN_KEY = 'authentication';

export const REQUEST_PATH = '/mobile-end';

export const FILE_VIEW_URL =
  '//cdn.myxrk.com/myxrk-v2/front-end/html/file-view/index.html';

export const REQUEST_DOMAIN = runConfig['run_request_domain'];
